export enum ROUTES {
  ALL = "*",
  HOME = "/",
  REQUEST_CARD = "/request-card",
  NOVATION_CONTRACT = "/novation-contract",
  UNSIGNED_NOVATION_CONTRACT = "/unsigned-novation-contract",
  APP_DOWNLOAD = "/app-download",
  ADD_EMAIL = "/add-email",
  REGISTER_COMPLETED = "/register-completed",
  SIGN_IN = "/sign-in",
  BIRTHDATE = "/add-birthdate",
  ADD_ADDRESS = "/add-address",
  ADD_PHONE = "/add-phone",
  PROFILE = "/profile",
  PAGE_FAILED = "/failed",
  TRANSACTIONS = "/transactions",
  VIRTUAL_CARD_DETAILS_ID = "/profile/virtual-card-details/:cardId",
  CHAT = "/chat",
  APPLE_PAY_FAQ = "/apple-pay-faq",
}
